import React from "react";
import { Calculator, Sparkles, Sliders, FolderOpen } from "lucide-react";
import { Link } from "react-router-dom";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "gelismis", label: "Gelişmiş Hesap", icon: Calculator },
    { id: "on-hesap", label: "Ön Hesap", icon: Sparkles },
    { id: "kalibrasyon", label: "Kalibrasyon", icon: Sliders },
    { id: "kayitlar", label: "DK Kayıtları", icon: FolderOpen },
];

export function DkKayitlarTab() {
    return (
        <div className="p-6 max-w-3xl space-y-4">
            <div className="rounded-2xl border border-white/10 bg-[#0a1018]/80 p-6">
                <h2 className="text-lg font-semibold text-white">Değer Kaybı Kayıtları</h2>
                <p className="text-sm text-slate-500 mt-2">
                    Klasik DK dosya listesi, filtreler ve CRUD işlemleri entity ekranında tutulur.
                    Hesap motoru bu merkezin diğer sekmelerinde.
                </p>
                <Link
                    to="/e/deger-kaybi"
                    className="mt-5 inline-flex items-center gap-2 rounded-xl bg-[#D4AF37] px-4 py-2.5 text-sm font-bold text-slate-900"
                >
                    <FolderOpen className="h-4 w-4" />
                    DK kayıt listesini aç
                </Link>
            </div>
        </div>
    );
}

export default function DegerKaybiMerkezLayout() {
    return (
        <MerkezHubShell
            title="Değer Kaybı Merkezi"
            subtitle="Gelişmiş hesap, ön tahmin, kalibrasyon ve kayıt listesi tek çatı altında."
            badge="Değer Kaybı · Hesap Motoru"
            basePath="/yeni/deger-kaybi-merkezi"
            tabs={TABS}
        />
    );
}
